import HomePageContainer from './container';

export default HomePageContainer;
